// 
import $ from 'jquery';
import { getJQuery } from './partialUpdateUtils';

const changedForms = {};
const CHANGED_HTML_CLASS = 'changed';

/**
 * Zapne chcekování změn ve formulářích.
 * Tj. pokud jsou změny ve formuláři, tak se PU přeruší.
 * Jsou ignorované změny z komponent a inputů, které jsou uvnitř
 * elementu s dattributem data-ignore-changes="true" nebo ten atribut přímo mají.
 */
export const partialUpdateMountChangesChecker = () => {
  /*
    document.body.addEventListener('change', (e) => {
      console.log(e);
    });
  */

  $(document.body).on('change', 'form', (e) => {
    const componentEl = $(e.target);
    const form = $(e.currentTarget);
    const formId = e.currentTarget.getAttribute('id');
    if (changedForms[formId] == null) {
      const componentIgnoreChangesDataset = componentEl.closest('[data-ignore-changes="true"]');
      const allowChangeDetection = componentIgnoreChangesDataset.length === 0;
      changedForms[formId] = allowChangeDetection;
      if (allowChangeDetection) {
        form.addClass(CHANGED_HTML_CLASS);
      }
    }
  });
};

/**
 * Zjištění jestli uvnitř elementu byly ůrovodené změny
 */
export const containsChangedForm = (element) => {
  element = getJQuery(element);
  const isForm = element.is('form');
  const childForms = isForm ? element : element.find('form');
  let containsChangedForms = false;
  if (childForms.length > 0) {
    childForms.toArray().forEach((childForm) => {
      const formId = childForm.getAttribute('id');
      if (!containsChangedForms) {
        containsChangedForms = !!changedForms[formId];
      }
    });
  }
  return containsChangedForms;
};

/**
 * Smaže příznak změny
 */
export const clearChangedFlagForContainedForm = (element) => {
  element = getJQuery(element);
  const isForm = element.is('form');
  const forms = isForm ? element : element.find('form');
  forms.toArray().forEach((form) => {
    const $form = $(form);
    const formId = $form.attr('id');
    $form.removeClass(CHANGED_HTML_CLASS);
    delete changedForms[formId];
  });
};

// export for use in fg-library
window.clearChangedFlagForContainedForm = clearChangedFlagForContainedForm;



// WEBPACK FOOTER //
// ./node_modules/fg-frontend/src/partialUpdate/formsChangesChecker.js